import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { ReleasesAllowlistModal } from '@components/modals/AllowlistModal/ReleaseAllowlistModal';
import { ModalContext, ModalType } from '@context/modal';

//TODO: gel add test
export const PresaleBadge = ({
  releaseId,
  merkleRoot,
  hasPresaleAccess,
}: {
  releaseId: string;
  hasPresaleAccess: boolean;
  merkleRoot: string | null;
}) => {
  const { openModal } = ModalContext.useContainer();

  return (
    <div
      className="flex h-4 cursor-pointer items-center"
      onClick={() => {
        openModal(ModalType.RELEASE_ALLOWLIST, {
          body: <ReleasesAllowlistModal releaseId={releaseId} merkleRoot={merkleRoot} />,
        });
      }}
    >
      {hasPresaleAccess ? (
        <div className="flex items-center gap-1 font-base text-base-s font-semibold text-fuchsia500 hover:text-[rgba(235,92,187,0.9)] hover:underline">
          <FontAwesomeIcon icon={faCircleCheck} fontSize={14} />
          Presale Eligible
        </div>
      ) : (
        <span className="font-base text-base-s font-semibold text-base800 hover:text-base700 hover:underline">
          with Presale
        </span>
      )}
    </div>
  );
};
